var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.46479V6H20V6.46481L12 11.7981L4 6.46479ZM2 6.98552C1.99988 6.99455 1.99988 7.00358 2 7.01261V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V7.01467C22.0002 7.00427 22.0002 6.99387 22 6.98346V5C22 4.44772 21.5523 4 21 4H3C2.44772 4 2 4.44772 2 5V6.98552ZM20 8.86851V18H4V8.86849L11.4453 13.832C11.7812 14.056 12.2188 14.056 12.5547 13.832L20 8.86851Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e1648726.svg";
export { ForwardRef as ReactComponent };